import type { ReactNode } from 'react';

// Título de una sección dentro de una página (debajo del Header).
// Ver design.md › Tipografía.
const SectionTitle = ({
  title,
  description,
  actions,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}) => (
  <div className='mb-3 flex flex-col gap-2 md:flex-row md:items-start md:justify-between'>
    <div className='flex flex-col gap-1'>
      <h3 className='text-lg font-semibold text-foreground'>{title}</h3>
      {description ? (
        <p className='text-sm text-default-500'>{description}</p>
      ) : null}
    </div>
    {actions ? <div className='flex gap-2'>{actions}</div> : null}
  </div>
);

export default SectionTitle;
